// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import CategoryPopup from "./CategoryPopup";
// import { Search, X, Loader2, Menu, AlertCircle } from "lucide-react";
// import Fuse from "fuse.js";
// import { fetchProducts, fetchFilterOptions } from "../services/api";

// const MenuAndSearchBar = () => {
//   const navigate = useNavigate();

//   const [isPopupOpen, setIsPopupOpen] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [searchType, setSearchType] = useState("buy");
  
//   // ✅ NEW: Separate states for products and categories
//   const [searchResults, setSearchResults] = useState([]);
//   const [categoryResults, setCategoryResults] = useState([]);
  
//   const [showResults, setShowResults] = useState(false);
//   const [isSearching, setIsSearching] = useState(false);
//   const [searchError, setSearchError] = useState(null);
//   const [totalResults, setTotalResults] = useState(0);
//   const [cachedProducts, setCachedProducts] = useState([]);
  
//   // ✅ NEW: Category cache
//   const [cachedCategories, setCachedCategories] = useState([]);

//   const allProductsButtonRef = useRef(null);
//   const mobileAllProductsButtonRef = useRef(null);
//   const searchRef = useRef(null);
//   const searchResultsRef = useRef(null);
//   const debounceTimer = useRef(null);
//   const popupTimerRef = useRef(null);
//   const fuseRef = useRef(null);
//   const fuseCategoriesRef = useRef(null); // ✅ NEW: Fuse for categories

//   // ✅ Fuse.js setup for products
//   useEffect(() => {
//     if (cachedProducts.length > 0) {
//       fuseRef.current = new Fuse(cachedProducts, {
//         keys: ["name"],
//         threshold: 0.4,
//         distance: 100,
//         minMatchCharLength: 2,
//         includeScore: true,
//       });
//     }
//   }, [cachedProducts]);

//   // ✅ NEW: Fuse.js setup for categories
//   useEffect(() => {
//     if (cachedCategories.length > 0) {
//       fuseCategoriesRef.current = new Fuse(cachedCategories, {
//         keys: ["name", "slug"],
//         threshold: 0.3,
//         distance: 100,
//         minMatchCharLength: 2,
//         includeScore: true,
//       });
//     }
//   }, [cachedCategories]);

//   // ✅ Preload products cache
//   useEffect(() => {
//     const preloadProducts = async () => {
//       try {
//         const data = await fetchProducts({ taxonomy: "equipment-buy", per_page: 100 });
//         setCachedProducts(data.products || []);
//       } catch (error) {
//         console.warn("Prefetch failed:", error);
//       }
//     };
//     preloadProducts();
//   }, []);

//   // ✅ NEW: Preload categories cache
//   useEffect(() => {
//     const preloadCategories = async () => {
//       try {
//         const data = await fetchFilterOptions("equipment-buy");
//         const categories = data.filters?.product_cat?.options || [];
//         setCachedCategories(categories);
//       } catch (error) {
//         console.warn("Category prefetch failed:", error);
//       }
//     };
//     preloadCategories();
//   }, []);

//   // ✅ Popup handlers
//   const handlePopupMouseEnter = () => {
//     if (popupTimerRef.current) clearTimeout(popupTimerRef.current);
//     setIsPopupOpen(true);
//   };

//   const handlePopupMouseLeave = () => {
//     popupTimerRef.current = setTimeout(() => setIsPopupOpen(false), 300);
//   };

//   const handleClosePopup = () => setIsPopupOpen(false);
  
//   const handleCategorySelect = () => {
//     setIsPopupOpen(false);
//     setIsMobileMenuOpen(false);
//   };

//   // ✅ Click outside handler
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       const isOutsideSearch =
//         searchRef.current && !searchRef.current.contains(event.target);
//       const isOutsideResults =
//         searchResultsRef.current &&
//         !searchResultsRef.current.contains(event.target);
//       if (isOutsideSearch && isOutsideResults) {
//         setShowResults(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // ✅ Cleanup
//   useEffect(() => {
//     return () => {
//       if (debounceTimer.current) clearTimeout(debounceTimer.current);
//       if (popupTimerRef.current) clearTimeout(popupTimerRef.current);
//     };
//   }, []);

//   // ✅ Normalize query
//   const normalizeQuery = (query) =>
//     query
//       .toLowerCase()
//       .replace(/[^\p{L}\p{N}\s]/gu, " ")
//       .replace(/\s+/g, " ")
//       .trim();

//   // ✅ NEW: Enhanced search with categories
//   const performSearch = async (query, type, showSuggestions = true) => {
//     const rawQuery = query.trim();
//     if (!rawQuery || rawQuery.length < 2) {
//       setSearchResults([]);
//       setCategoryResults([]);
//       setShowResults(false);
//       setTotalResults(0);
//       setSearchError(null);
//       return;
//     }

//     setIsSearching(true);
//     setSearchError(null);

//     try {
//       const cleanedQuery = normalizeQuery(rawQuery);
//       const taxonomy = type === "buy" ? "equipment-buy" : "equipment-rent";

//       // 1️⃣ Fetch Products
//       const productResponse = await fetchProducts({
//         taxonomy,
//         search: cleanedQuery,
//         page: 1,
//         per_page: showSuggestions ? 6 : 11, // Reduced for categories
//       });

//       let products = productResponse?.products || [];

//       // Cache products for Fuse.js
//       if (products.length > 0) {
//         setCachedProducts((prev) => {
//           const map = new Map(prev.map((p) => [p.id, p]));
//           products.forEach((r) => map.set(r.id, r));
//           return Array.from(map.values());
//         });
//       }

//       // Fuse.js fallback for products
//       if (products.length === 0 && fuseRef.current) {
//         const fuzzyMatches = fuseRef.current.search(cleanedQuery);
//         products = fuzzyMatches.map((match) => match.item).slice(0, 5);
//       }

//       // 2️⃣ NEW: Search Categories
//       let categories = [];
      
//       // Try Fuse.js first (faster)
//       if (fuseCategoriesRef.current) {
//         const fuzzyCategories = fuseCategoriesRef.current.search(cleanedQuery);
//         categories = fuzzyCategories.map((match) => match.item).slice(0, 3);
//       }

//       // If no Fuse results, try API
//       if (categories.length === 0) {
//         try {
//           const filterResponse = await fetchFilterOptions(taxonomy);
//           const allCategories = filterResponse.filters?.product_cat?.options || [];
          
//           // Filter categories by search query
//           categories = allCategories
//             .filter((cat) => 
//               cat.name.toLowerCase().includes(cleanedQuery) ||
//               cat.slug.toLowerCase().includes(cleanedQuery)
//             )
//             .slice(0, 3);

//           // Update cache
//           if (allCategories.length > 0) {
//             setCachedCategories(allCategories);
//           }
//         } catch (error) {
//           console.warn("Category search failed:", error);
//         }
//       }

//       setSearchResults(products);
//       setCategoryResults(categories);
//       setTotalResults(products.length + categories.length);
//       setShowResults(products.length > 0 || categories.length > 0);
      
//     } catch (error) {
//       console.error("Search error:", error);
//       setSearchResults([]);
//       setCategoryResults([]);
//       setTotalResults(0);
//       setShowResults(false);
//       setSearchError("Unable to search. Please try again.");
//     } finally {
//       setIsSearching(false);
//     }
//   };

//   // ✅ Debounce typing
//   const handleSearchChange = (e) => {
//     const value = e.target.value;
//     setSearchQuery(value);
//     setSearchError(null);
    
//     if (debounceTimer.current) clearTimeout(debounceTimer.current);
    
//     if (value.trim().length < 2) {
//       setSearchResults([]);
//       setCategoryResults([]);
//       setShowResults(false);
//       setTotalResults(0);
//       return;
//     }
    
//     debounceTimer.current = setTimeout(() => {
//       performSearch(value, searchType, true);
//     }, 300);
//   };

//   // ✅ Helper actions
//   const handleSearchTypeChange = (type) => {
//     setSearchType(type);
//     if (searchQuery.trim().length >= 2) {
//       performSearch(searchQuery, type, true);
//     }
//   };

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     const trimmedQuery = searchQuery.trim();
//     if (!trimmedQuery) return;
    
//     const taxonomy = searchType === "buy" ? "equipment-buy" : "equipment-rent";
//     navigate(`/products?taxonomy=${taxonomy}&search=${encodeURIComponent(trimmedQuery)}`);
//     setShowResults(false);
//     setIsMobileMenuOpen(false);
//   };

//   // ✅ Product click handler
//   const handleProductClick = useCallback((product) => {
//     setShowResults(false);
//     setSearchQuery("");
//     setSearchResults([]);
//     setCategoryResults([]);
//     setTotalResults(0);
//     navigate(`/product/${product.slug}/gs${product.id}`);
//   }, [navigate]);

//   // ✅ NEW: Category click handler
//   const handleCategoryClick = useCallback((category) => {
//     setShowResults(false);
//     setSearchQuery("");
//     setSearchResults([]);
//     setCategoryResults([]);
//     setTotalResults(0);
//     const taxonomy = searchType === "buy" ? "equipment-buy" : "equipment-rent";
//     navigate(`/products?taxonomy=${taxonomy}&product_cat=${category.slug}`);
//   }, [navigate, searchType]);

//   const handleClearSearch = () => {
//     setSearchQuery("");
//     setSearchResults([]);
//     setCategoryResults([]);
//     setShowResults(false);
//     setTotalResults(0);
//     setSearchError(null);
//     if (debounceTimer.current) clearTimeout(debounceTimer.current);
//   };

//   const handleViewAllResults = () => {
//     const trimmedQuery = searchQuery.trim();
//     if (!trimmedQuery) return;
    
//     const taxonomy = searchType === "buy" ? "equipment-buy" : "equipment-rent";
//     navigate(`/products?taxonomy=${taxonomy}&search=${encodeURIComponent(trimmedQuery)}`);
//     setShowResults(false);
//     setSearchQuery("");
//   };

//   const highlightMatch = (text, query) => {
//     if (!query || !text) return text;
//     const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, "gi");
//     return text.replace(regex, '<span class="font-bold text-gray-900">$1</span>');
//   };

//   // ✅ Search Result Item
//   const SearchResultItem = ({ product, isMobile = false }) => (
//     <div
//       role="button"
//       tabIndex={0}
//       onMouseDown={() => handleProductClick(product)}
//       onClick={(e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         handleProductClick(product);
//       }}
//       onKeyDown={(e) => {
//         if (e.key === 'Enter' || e.key === ' ') {
//           e.preventDefault();
//           handleProductClick(product);
//         }
//       }}
//       className={`${
//         isMobile ? "px-3 py-2" : "px-4 py-3"
//       } hover:bg-gray-50 cursor-pointer border-b border-gray-100 transition-colors last:border-b-0`}
//     >
//       <h4
//         className={`font-medium text-gray-900 ${
//           isMobile ? "text-sm" : "text-base"
//         } line-clamp-2`}
//         dangerouslySetInnerHTML={{ 
//           __html: highlightMatch(product.name, searchQuery) 
//         }}
//       />
//     </div>
//   );

//   // ✅ NEW: Category Result Item
//   const CategoryResultItem = ({ category, isMobile = false }) => (
//     <div
//       role="button"
//       tabIndex={0}
//       onMouseDown={() => handleCategoryClick(category)}
//       onClick={(e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         handleCategoryClick(category);
//       }}
//       onKeyDown={(e) => {
//         if (e.key === 'Enter' || e.key === ' ') {
//           e.preventDefault();
//           handleCategoryClick(category);
//         }
//       }}
//       className={`${
//         isMobile ? "px-3 py-2" : "px-4 py-3"
//       } cursor-pointer border-b border-gray-100 transition-colors last:border-b-0 flex items-center gap-3`}
//     >
//       <div className="flex-1 min-w-0">
//         <h4
//           className={`font-semibold text-gray-900 ${
//             isMobile ? "text-base" : "text-xl"
//           } line-clamp-1`}
//           dangerouslySetInnerHTML={{ 
//             __html: highlightMatch(category.name, searchQuery) 
//           }}
//         />
//         {/* <p className="text-xs text-gray-500">
//           {category.count} {category.count === 1 ? 'product' : 'products'}
//         </p> */}
//       </div>
//     </div>
//   );

//   // ✅ NEW: Enhanced Search Results Dropdown
//   const SearchResultsDropdown = ({ isMobile = false }) => {
//     if (!showResults) return null;
    
//     const hasProducts = searchResults.length > 0;
//     const hasCategories = categoryResults.length > 0;
    
//     return (
//       <div
//         ref={searchResultsRef}
//         onMouseDown={(e) => e.stopPropagation()}
//         className={`absolute top-full left-0 right-0 mt-2 bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden ${
//           isMobile ? "max-w-full z-[100]" : "z-[100]"
//         }`}
//         style={{ 
//           boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)'}}
//       >
//         {searchError ? (
//           <div className="p-4 text-center">
//             <AlertCircle className="w-6 h-6 text-red-500 mx-auto mb-2" />
//             <p className="text-sm text-gray-600">{searchError}</p>
//           </div>
//         ) : (hasProducts || hasCategories) ? (
//           <>
//             <div className="max-h-[450px] overflow-y-auto">
//               {/* ✅ Categories Section */}
//               {hasCategories && (
//                 <div className="border-b border-gray-200">
//                   <div className="px-4 py-2">
//                     <p className="text-[15px] font-normal text-[#1A1A1A]  tracking-wide flex items-center gap-2">
                      
//                       Category
//                     </p>
//                   </div>
//                   <div>
//                     {categoryResults.map((category, index) => (
//                       <CategoryResultItem 
//                         key={category.slug || `category-${index}`} 
//                         category={category} 
//                         isMobile={isMobile} 
//                       />
//                     ))}
//                   </div>
//                 </div>
//               )}
              
//               {/* ✅ Products Section */}
//               {hasProducts && (
//                 <div>
//                   <div className="px-4 py-2">
//                     <p className="text-[15px] font-normal text-[#1A1A1A]">
//                       Search Results
//                     </p>
//                   </div>
//                   <div>
//                     {searchResults.map((product, index) => (
//                       <SearchResultItem 
//                         key={product.id || `product-${index}`} 
//                         product={product} 
//                         isMobile={isMobile} 
//                       />
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>
            
//             {/* Footer */}
//             <div className="px-4 py-3 bg-gray-50 border-t border-gray-200">
//               <button
//                 onClick={(e) => {
//                   e.preventDefault();
//                   e.stopPropagation();
//                   handleViewAllResults();
//                 }}
//                 className="w-full py-2 text-center text-sm font-medium text-[#1A1A1A] hover:text-gray-600 hover:bg-gray-100 rounded transition-colors"
//               >
//                 View All Results ({totalResults})
//               </button>
//             </div>
//           </>
//         ) : (
//           <div className="p-6 text-center text-gray-500">
//             No results for "<span className="font-medium">{searchQuery}</span>"
//           </div>
//         )}
//       </div>
//     );
//   };

//   return (
//     <>
//       <div className="bg-[#F5F1E6] py-4 lg:py-6">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           {/* ==================== DESKTOP VERSION ==================== */}
//           <div className="hidden lg:flex justify-between items-center">
//             {/* Left Navigation */}
//             <div className="flex items-center gap-6">
//               <div
//   ref={allProductsButtonRef}
//   onMouseEnter={handlePopupMouseEnter}
//   onMouseLeave={handlePopupMouseLeave}
//   className="relative flex items-center gap-1"
// >
//   <img 
//     className="w-4 h-4" 
//     src="/images/black-streamline-sharp_buttons-all-solid.png" 
//     alt="All" 
//   />
//   <button 
//     onClick={() => navigate("/products")} 
//     className="pl-1 px-4 py-2 font-semibold text-[#1A1A1A]"
//   >
//     <span className="nav-underline">All Products</span>
//   </button>
//   <img 
//     className="w-0.5 h-8" 
//     src="/images/blackLine.png" 
//     alt="divider" 
//   />
// </div>
              
//               <ul className="flex gap-6">
//                 <li>
//                   <Link to="/brands" className="nav-underline font-semibold">
//                     Brands
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/about-us" className="nav-underline font-semibold">
//                     About Us
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/contact" className="nav-underline font-semibold">
//                     Contact Us
//                   </Link>
//                 </li>
//               </ul>
//             </div>

//             {/* Desktop Search */}
//             <div className="relative z-20" ref={searchRef}>
//               <form 
//                 onSubmit={handleSearchSubmit} 
//                 className="flex items-center bg-white rounded-md p-[6px]" 
//                 style={{ boxShadow: "0px 1px 2px #B8C8E039" }}
//               >
//                 {/* Buy/Rent Toggle */}
//                 <fieldset className="flex bg-[#F5F1E6]">
//                   <input 
//                     type="radio" 
//                     id="buy" 
//                     name="intent" 
//                     checked={searchType === "buy"} 
//                     onChange={() => handleSearchTypeChange("buy")} 
//                     className="peer/buy sr-only" 
//                   />
//                   <label 
//                     htmlFor="buy" 
//                     className="px-3 py-2 font-semibold peer-checked/buy:bg-[#FFD200] cursor-pointer transition-colors"
//                   >
//                     Buy
//                   </label>
                  
//                   <input 
//                     type="radio" 
//                     id="rent" 
//                     name="intent" 
//                     checked={searchType === "rent"} 
//                     onChange={() => handleSearchTypeChange("rent")} 
//                     className="peer/rent sr-only" 
//                   />
//                   <label 
//                     htmlFor="rent" 
//                     className="px-3 py-2 font-semibold peer-checked/rent:bg-[#FFD200] cursor-pointer transition-colors"
//                   >
//                     Rent
//                   </label>
//                 </fieldset>

//                 {/* Search Input */}
//                 <div className="relative w-[450px]">
//                   <input
//                     type="search"
//                     value={searchQuery}
//                     onChange={handleSearchChange}
//                     onFocus={() => (searchResults.length > 0 || categoryResults.length > 0) && setShowResults(true)}
//                     placeholder="What are you looking for?"
//                     className="w-full h-10 pl-4 pr-20 text-[18px] placeholder:text-gray-300 outline-none"
//                     autoComplete="off"
//                   />
                  
//                   {/* Search Icons */}
//                   <div className="absolute right-3 top-1/2 -translate-y-1/2 flex gap-2 items-center">
//                     {isSearching && (
//                       <Loader2 className="w-5 h-5 animate-spin text-gray-400" />
//                     )}
//                     {searchQuery && !isSearching && (
//                       <button 
//                         type="button" 
//                         onClick={handleClearSearch}
//                         aria-label="Clear search"
//                         className="hover:bg-gray-100 rounded p-0.5 transition-colors"
//                       >
//                         <X className="w-5 h-5 text-gray-400" />
//                       </button>
//                     )}
//                     <button 
//                       type="submit" 
//                       disabled={!searchQuery.trim()}
//                       aria-label="Submit search"
//                       className="disabled:opacity-50 disabled:cursor-not-allowed"
//                     >
//                       <Search className="w-6 h-6 text-gray-400" />
//                     </button>
//                   </div>
//                 </div>
//               </form>
              
//               {/* Dropdown OUTSIDE form */}
//               <SearchResultsDropdown />
//             </div>
//           </div>

//           {/* ==================== MOBILE VERSION ==================== */}
//           <div className="lg:hidden">
//             {/* Mobile Header */}
//             <div className="flex justify-between items-center mb-3">
//               <button 
//                 onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} 
//                 className="p-2 text-[#1A1A1A] hover:bg-gray-100 rounded-lg transition-colors"
//                 aria-label="Toggle menu"
//               >
//                 <Menu className="w-6 h-6" />
//               </button>
              
//               <button 
//   ref={mobileAllProductsButtonRef}
//   onClick={() => setIsPopupOpen(true)} 
//   className="flex items-center gap-2 px-4 py-2 font-medium text-[#1A1A1A] hover:bg-gray-100 rounded-lg transition-colors"
// >
//   <img 
//     src="/images/black-streamline-sharp_buttons-all-solid.png" 
//     className="w-4 h-4" 
//     alt="All" 
//   />
//   <span>All Products</span>
// </button>
//             </div>

//             {/* Mobile Menu */}
//             {isMobileMenuOpen && (
//               <div className="mb-3 p-3 bg-white rounded-lg shadow-sm">
//                 <ul className="flex flex-col gap-3">
//                   <li>
//                     <Link 
//                       to="/brands" 
//                       className="block font-semibold hover:text-gray-600 transition-colors" 
//                       onClick={() => setIsMobileMenuOpen(false)}
//                     >
//                       Brands
//                     </Link>
//                   </li>
//                   <li>
//                     <Link 
//                       to="/about-us" 
//                       className="block font-semibold hover:text-gray-600 transition-colors" 
//                       onClick={() => setIsMobileMenuOpen(false)}
//                     >
//                       About Us
//                     </Link>
//                   </li>
//                   <li>
//                     <Link 
//                       to="/contact" 
//                       className="block font-semibold hover:text-gray-600 transition-colors" 
//                       onClick={() => setIsMobileMenuOpen(false)}
//                     >
//                       Contact Us
//                     </Link>
//                   </li>
//                 </ul>
//               </div>
//             )}

//             {/* Mobile Search */}
//             <div className="relative" ref={searchRef}>
//               <form 
//                 onSubmit={handleSearchSubmit} 
//                 className="bg-white rounded-md p-2" 
//                 style={{ boxShadow: "0px 1px 2px #B8C8E039" }}
//               >
//                 {/* Mobile Buy/Rent Toggle */}
//                 <fieldset className="flex bg-[#F5F1E6] mb-2">
//                   <input 
//                     type="radio" 
//                     id="buy-mobile" 
//                     name="intent-mobile" 
//                     checked={searchType === "buy"} 
//                     onChange={() => handleSearchTypeChange("buy")} 
//                     className="peer/buy sr-only" 
//                   />
//                   <label 
//                     htmlFor="buy-mobile" 
//                     className="flex-1 text-center py-2 text-sm font-semibold cursor-pointer peer-checked/buy:bg-[#FFD200] transition-colors"
//                   >
//                     Buy
//                   </label>
                  
//                   <input 
//                     type="radio" 
//                     id="rent-mobile" 
//                     name="intent-mobile" 
//                     checked={searchType === "rent"} 
//                     onChange={() => handleSearchTypeChange("rent")} 
//                     className="peer/rent sr-only" 
//                   />
//                   <label 
//                     htmlFor="rent-mobile" 
//                     className="flex-1 text-center py-2 text-sm font-semibold cursor-pointer peer-checked/rent:bg-[#FFD200] transition-colors"
//                   >
//                     Rent
//                   </label>
//                 </fieldset>

//                 {/* Mobile Search Input */}
//                 <div className="relative">
//                   <input
//                     type="search"
//                     value={searchQuery}
//                     onChange={handleSearchChange}
//                     onFocus={() => (searchResults.length > 0 || categoryResults.length > 0) && setShowResults(true)}
//                     placeholder="What are you looking for?"
//                     className="w-full h-10 pl-4 pr-16 text-base placeholder:text-gray-300 outline-none"
//                     autoComplete="off"
//                   />
                  
//                   {/* Mobile Search Icons */}
//                   <div className="absolute right-2 top-1/2 -translate-y-1/2 flex gap-2 items-center">
//                     {isSearching && (
//                       <Loader2 className="w-4 h-4 text-gray-400 animate-spin" />
//                     )}
//                     {searchQuery && !isSearching && (
//                       <button 
//                         type="button" 
//                         onClick={handleClearSearch}
//                         aria-label="Clear search"
//                         className="hover:bg-gray-100 rounded p-0.5 transition-colors"
//                       >
//                         <X className="w-4 h-4 text-gray-400" />
//                       </button>
//                     )}
//                     <button 
//                       type="submit" 
//                       disabled={!searchQuery.trim()}
//                       aria-label="Submit search"
//                       className="disabled:opacity-50 disabled:cursor-not-allowed"
//                     >
//                       <Search className="w-5 h-5 text-gray-400" />
//                     </button>
//                   </div>
//                 </div>
//               </form>
              
//               {/* Mobile Search Results Dropdown */}
//               <SearchResultsDropdown isMobile={true} />
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Category Popup */}
//         <CategoryPopup
//   isOpen={isPopupOpen}
//   onClose={handleClosePopup}
//   onSelectCategory={handleCategorySelect}
//   onMouseEnter={handlePopupMouseEnter}
//   onMouseLeave={handlePopupMouseLeave}
//   triggerRef={window.innerWidth >= 1024 ? allProductsButtonRef : mobileAllProductsButtonRef}
// />
      
//       {/* Styles */}
//       <style jsx>{`
//         .nav-underline {
//           position: relative;
//           display: inline-block;
//         }
//         .nav-underline::after {
//           content: "";
//           position: absolute;
//           bottom: -2px;
//           left: 0;
//           width: 0%;
//           height: 2px;
//           background-color: #1a1a1a;
//           transition: width 0.3s ease;
//         }
//         .nav-underline:hover::after {
//           width: 100%;
//         }
//       `}</style>
//     </>
//   );
// };

// export default MenuAndSearchBar;

import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import CategoryPopup from "./CategoryPopup";
import { Search, X, Loader2, Menu, AlertCircle } from "lucide-react";
import Fuse from "fuse.js";
import { fetchProducts, fetchFilterOptions } from "../services/api";
const MenuAndSearchBar = () => {
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchType, setSearchType] = useState("buy");
  const [searchResults, setSearchResults] = useState([]);
  const [categoryResults, setCategoryResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchError, setSearchError] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [cachedProducts, setCachedProducts] = useState([]);
  const [cachedCategories, setCachedCategories] = useState([]);
  const allProductsButtonRef = useRef(null);
  const mobileAllProductsButtonRef = useRef(null);
  const searchRef = useRef(null);
  const searchResultsRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const debounceTimer = useRef(null);
  const popupTimerRef = useRef(null);
  const fuseRef = useRef(null);
  const fuseCategoriesRef = useRef(null);

  // Fuse.js setup for products
  useEffect(() => {
    if (cachedProducts.length > 0) {
      fuseRef.current = new Fuse(cachedProducts, {
        keys: ["name"],
        threshold: 0.4,
        distance: 100,
        minMatchCharLength: 2,
        includeScore: true,
      });
    }
  }, [cachedProducts]);

  // Fuse.js setup for categories
  useEffect(() => {
    if (cachedCategories.length > 0) {
      fuseCategoriesRef.current = new Fuse(cachedCategories, {
        keys: ["name", "slug"],
        threshold: 0.3,
        distance: 100,
        minMatchCharLength: 2,
        includeScore: true,
      });
    }
  }, [cachedCategories]);

  // Preload products cache
  useEffect(() => {
    const preloadProducts = async () => {
      try {
        const data = await fetchProducts({ taxonomy: "equipment-buy", per_page: 100 });
        setCachedProducts(data.products || []);
      } catch (error) {
        console.warn("Prefetch failed:", error);
      }
    };
    preloadProducts();
  }, []);

  // Preload categories cache
  useEffect(() => {
    const preloadCategories = async () => {
      try {
        const data = await fetchFilterOptions("equipment-buy");
        const categories = data.filters?.product_cat?.options || [];
        setCachedCategories(categories);
      } catch (error) {
        console.warn("Category prefetch failed:", error);
      }
    };
    preloadCategories();
  }, []);

  // ✅ NEW: Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  // ✅ NEW: Click outside handler for mobile menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileMenuOpen && mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) {
        // Check if click is not on the menu button itself
        const menuButton = event.target.closest('button[aria-label="Toggle menu"]');
        if (!menuButton) {
          setIsMobileMenuOpen(false);
        }
      }
    };
    
    if (isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  // Popup handlers
  const handlePopupMouseEnter = () => {
    if (popupTimerRef.current) clearTimeout(popupTimerRef.current);
    setIsPopupOpen(true);
  };

  const handlePopupMouseLeave = () => {
    popupTimerRef.current = setTimeout(() => setIsPopupOpen(false), 300);
  };

  const handleClosePopup = () => setIsPopupOpen(false);
  
  const handleCategorySelect = () => {
    setIsPopupOpen(false);
    setIsMobileMenuOpen(false);
  };

  // Click outside handler for search
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutsideSearch =
        searchRef.current && !searchRef.current.contains(event.target);
      const isOutsideResults =
        searchResultsRef.current &&
        !searchResultsRef.current.contains(event.target);
      if (isOutsideSearch && isOutsideResults) {
        setShowResults(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Cleanup
  useEffect(() => {
    return () => {
      if (debounceTimer.current) clearTimeout(debounceTimer.current);
      if (popupTimerRef.current) clearTimeout(popupTimerRef.current);
    };
  }, []);

  // Normalize query
  const normalizeQuery = (query) =>
    query
      .toLowerCase()
      .replace(/[^\p{L}\p{N}\s]/gu, " ")
      .replace(/\s+/g, " ")
      .trim();

  // Enhanced search with categories
  const performSearch = async (query, type, showSuggestions = true) => {
    const rawQuery = query.trim();
    if (!rawQuery || rawQuery.length < 2) {
      setSearchResults([]);
      setCategoryResults([]);
      setShowResults(false);
      setTotalResults(0);
      setSearchError(null);
      return;
    }

    setIsSearching(true);
    setSearchError(null);

    try {
      const cleanedQuery = normalizeQuery(rawQuery);
      const taxonomy = type === "buy" ? "equipment-buy" : "equipment-rent";

      const productResponse = await fetchProducts({
        taxonomy,
        search: cleanedQuery,
        page: 1,
        per_page: showSuggestions ? 6 : 11,
      });

      let products = productResponse?.products || [];

      if (products.length > 0) {
        setCachedProducts((prev) => {
          const map = new Map(prev.map((p) => [p.id, p]));
          products.forEach((r) => map.set(r.id, r));
          return Array.from(map.values());
        });
      }

      if (products.length === 0 && fuseRef.current) {
        const fuzzyMatches = fuseRef.current.search(cleanedQuery);
        products = fuzzyMatches.map((match) => match.item).slice(0, 5);
      }

      let categories = [];
      
      if (fuseCategoriesRef.current) {
        const fuzzyCategories = fuseCategoriesRef.current.search(cleanedQuery);
        categories = fuzzyCategories.map((match) => match.item).slice(0, 3);
      }

      if (categories.length === 0) {
        try {
          const filterResponse = await fetchFilterOptions(taxonomy);
          const allCategories = filterResponse.filters?.product_cat?.options || [];
          
          categories = allCategories
            .filter((cat) => 
              cat.name.toLowerCase().includes(cleanedQuery) ||
              cat.slug.toLowerCase().includes(cleanedQuery)
            )
            .slice(0, 3);

          if (allCategories.length > 0) {
            setCachedCategories(allCategories);
          }
        } catch (error) {
          console.warn("Category search failed:", error);
        }
      }

      setSearchResults(products);
      setCategoryResults(categories);
      setTotalResults(products.length + categories.length);
      setShowResults(products.length > 0 || categories.length > 0);
      
    } catch (error) {
      console.error("Search error:", error);
      setSearchResults([]);
      setCategoryResults([]);
      setTotalResults(0);
      setShowResults(false);
      setSearchError("Unable to search. Please try again.");
    } finally {
      setIsSearching(false);
    }
  };

  // Debounce typing
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    setSearchError(null);
    
    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    
    if (value.trim().length < 2) {
      setSearchResults([]);
      setCategoryResults([]);
      setShowResults(false);
      setTotalResults(0);
      return;
    }
    
    debounceTimer.current = setTimeout(() => {
      performSearch(value, searchType, true);
    }, 300);
  };

  const handleSearchTypeChange = (type) => {
    setSearchType(type);
    if (searchQuery.trim().length >= 2) {
      performSearch(searchQuery, type, true);
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const trimmedQuery = searchQuery.trim();
    if (!trimmedQuery) return;
    
    const taxonomy = searchType === "buy" ? "equipment-buy" : "equipment-rent";
    navigate(`/products?taxonomy=${taxonomy}&search=${encodeURIComponent(trimmedQuery)}`);
    setShowResults(false);
    setIsMobileMenuOpen(false);
  };

  const handleProductClick = useCallback((product) => {
    setShowResults(false);
    setSearchQuery("");
    setSearchResults([]);
    setCategoryResults([]);
    setTotalResults(0);
    navigate(`/product/${product.slug}/gs${product.id}`);
  }, [navigate]);

  const handleCategoryClick = useCallback((category) => {
    setShowResults(false);
    setSearchQuery("");
    setSearchResults([]);
    setCategoryResults([]);
    setTotalResults(0);
    const taxonomy = searchType === "buy" ? "equipment-buy" : "equipment-rent";
    navigate(`/products?taxonomy=${taxonomy}&product_cat=${category.slug}`);
  }, [navigate, searchType]);

  const handleClearSearch = () => {
    setSearchQuery("");
    setSearchResults([]);
    setCategoryResults([]);
    setShowResults(false);
    setTotalResults(0);
    setSearchError(null);
    if (debounceTimer.current) clearTimeout(debounceTimer.current);
  };

  const handleViewAllResults = () => {
    const trimmedQuery = searchQuery.trim();
    if (!trimmedQuery) return;
    const taxonomy = searchType === "buy" ? "equipment-buy" : "equipment-rent";
    navigate(`/products?taxonomy=${taxonomy}&search=${encodeURIComponent(trimmedQuery)}`);
    setShowResults(false);
    setSearchQuery("");
  };

  const highlightMatch = (text, query) => {
    if (!query || !text) return text;
    const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, "gi");
    return text.replace(regex, '<span class="font-bold text-gray-900">$1</span>');
  };

  const SearchResultItem = ({ product, isMobile = false }) => (
    <div
      role="button"
      tabIndex={0}
      onMouseDown={() => handleProductClick(product)}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        handleProductClick(product);
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleProductClick(product);
        }
      }}
      className={`${
        isMobile ? "px-3 py-2" : "px-4 py-3"
      } hover:bg-gray-50 cursor-pointer border-b border-gray-100 transition-colors last:border-b-0`}
    >
      <h4
        className={`font-medium text-gray-900 ${
          isMobile ? "text-sm" : "text-base"
        } line-clamp-2`}
        dangerouslySetInnerHTML={{ 
          __html: highlightMatch(product.name, searchQuery) 
        }}
      />
    </div>
  );

  const CategoryResultItem = ({ category, isMobile = false }) => (
    <div
      role="button"
      tabIndex={0}
      onMouseDown={() => handleCategoryClick(category)}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        handleCategoryClick(category);
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleCategoryClick(category);
        }
      }}
      className={`${
        isMobile ? "px-3 py-2" : "px-4 py-3"
      } cursor-pointer border-b border-gray-100 transition-colors last:border-b-0 flex items-center gap-3`}
    >
      <div className="flex-1 min-w-0">
        <h4
          className={`font-semibold text-gray-900 ${
            isMobile ? "text-base" : "text-xl"
          } line-clamp-1`}
          dangerouslySetInnerHTML={{ 
            __html: highlightMatch(category.name, searchQuery) 
          }}
        />
      </div>
    </div>
  );

  const SearchResultsDropdown = ({ isMobile = false }) => {
    if (!showResults) return null;
    const hasProducts = searchResults.length > 0;
    const hasCategories = categoryResults.length > 0;
    return (
      <div
        ref={searchResultsRef}
        onMouseDown={(e) => e.stopPropagation()}
        className={`absolute top-full left-0 right-0 mt-2 bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden ${
          isMobile ? "max-w-full z-[100]" : "z-[100]"
        }`}
        style={{ 
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)'}}
      >
        {searchError ? (
          <div className="p-4 text-center">
            <AlertCircle className="w-6 h-6 text-red-500 mx-auto mb-2" />
            <p className="text-sm text-gray-600">{searchError}</p>
          </div>
        ) : (hasProducts || hasCategories) ? (
          <>
            <div className="max-h-[450px] overflow-y-auto">
              {hasCategories && (
                <div className="border-b border-gray-200">
                  <div className="px-4 py-2">
                    <p className="text-[15px] font-normal text-[#1A1A1A] tracking-wide flex items-center gap-2">
                      Category
                    </p>
                  </div>
                  <div>
                    {categoryResults.map((category, index) => (
                      <CategoryResultItem 
                        key={category.slug || `category-${index}`} 
                        category={category} 
                        isMobile={isMobile} 
                      />
                    ))}
                  </div>
                </div>
              )}
              
              {hasProducts && (
                <div>
                  <div className="px-4 py-2">
                    <p className="text-[15px] font-normal text-[#1A1A1A]">
                      Search Results
                    </p>
                  </div>
                  <div>
                    {searchResults.map((product, index) => (
                      <SearchResultItem 
                        key={product.id || `product-${index}`} 
                        product={product} 
                        isMobile={isMobile} 
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>
            
            <div className="px-4 py-3 bg-gray-50 border-t border-gray-200">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleViewAllResults();
                }}
                className="w-full py-2 text-center text-sm font-medium text-[#1A1A1A] hover:text-gray-600 hover:bg-gray-100 rounded transition-colors"
              >
                View All Results ({totalResults})
              </button>
            </div>
          </>
        ) : (
          <div className="p-6 text-center text-gray-500">
            No results for "<span className="font-medium">{searchQuery}</span>"
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="bg-[#F5F1E6] py-4 lg:py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* ==================== DESKTOP VERSION ==================== */}
          <div className="hidden lg:flex justify-between items-center">
            <div className="flex items-center gap-6">
              <div
                ref={allProductsButtonRef}
                onMouseEnter={handlePopupMouseEnter}
                onMouseLeave={handlePopupMouseLeave}
                className="relative flex items-center gap-1"
              >
                <img 
                  className="w-4 h-4" 
                  src="/images/black-streamline-sharp_buttons-all-solid.png" 
                  alt="All" 
                />
                <button 
                  onClick={() => navigate("/products")} 
                  className="pl-1 px-4 py-2 font-semibold text-[#1A1A1A]"
                >
                  <span className="nav-underline">All Products</span>
                </button>
                <img 
                  className="w-0.5 h-8" 
                  src="/images/blackLine.png" 
                  alt="divider" 
                />
              </div>
              
              <ul className="flex gap-6">
                <li>
                  <Link to="/brands" className="nav-underline font-semibold">
                    Brands
                  </Link>
                </li>
                <li>
                  <Link to="/about-us" className="nav-underline font-semibold">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="nav-underline font-semibold">
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            <div className="relative z-20" ref={searchRef}>
              <form 
                onSubmit={handleSearchSubmit} 
                className="flex items-center bg-white rounded-md p-[6px]" 
                style={{ boxShadow: "0px 1px 2px #B8C8E039" }}
              >
                <fieldset className="flex bg-[#F5F1E6]">
                  <input 
                    type="radio" 
                    id="buy" 
                    name="intent" 
                    checked={searchType === "buy"} 
                    onChange={() => handleSearchTypeChange("buy")} 
                    className="peer/buy sr-only" 
                  />
                  <label 
                    htmlFor="buy" 
                    className="m-0 px-3 py-2 font-semibold peer-checked/buy:bg-[#FFD200] cursor-pointer transition-colors"
                  >
                    Buy
                  </label>
                  
                  <input 
                    type="radio" 
                    id="rent" 
                    name="intent" 
                    checked={searchType === "rent"} 
                    onChange={() => handleSearchTypeChange("rent")} 
                    className="peer/rent sr-only" 
                  />
                  <label 
                    htmlFor="rent" 
                    className="m-0 px-3 py-2 font-semibold peer-checked/rent:bg-[#FFD200] cursor-pointer transition-colors"
                  >
                    Rent
                  </label>
                </fieldset>

                <div className="relative w-[450px]">
                  <input
                    type="search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    onFocus={() => (searchResults.length > 0 || categoryResults.length > 0) && setShowResults(true)}
                    placeholder="What are you looking for?"
                    className="w-full h-10 pl-4 pr-20 text-[18px] placeholder:text-gray-300 outline-none"
                    autoComplete="off"
                  />
                  
                  <div className="absolute right-3 top-1/2 -translate-y-1/2 flex gap-2 items-center">
                    {isSearching && (
                      <Loader2 className="w-5 h-5 animate-spin text-gray-400" />
                    )}
                    {searchQuery && !isSearching && (
                      <button 
                        type="button" 
                        onClick={handleClearSearch}
                        aria-label="Clear search"
                        className="hover:bg-gray-100 rounded p-0.5 transition-colors"
                      >
                        <X className="w-5 h-5 text-gray-400" />
                      </button>
                    )}
                    <button 
                      type="submit" 
                      disabled={!searchQuery.trim()}
                      aria-label="Submit search"
                      className="disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <Search className="w-6 h-6 text-gray-400" />
                    </button>
                  </div>
                </div>
              </form>
              
              <SearchResultsDropdown />
            </div>
          </div>

          {/* ==================== MOBILE VERSION ==================== */}
          <div className="lg:hidden">
            {/* Mobile Header - NO LAYOUT SHIFT */}
            <div className="flex justify-between items-center mb-3">
              <button 
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} 
                className="p-2 text-[#1A1A1A] hover:bg-gray-100 rounded-lg transition-colors"
                aria-label="Toggle menu"
              >
                <Menu className="w-6 h-6" />
              </button>
              
              <button 
                ref={mobileAllProductsButtonRef}
                onClick={() => setIsPopupOpen(true)} 
                className="flex items-center gap-2 px-4 py-2 font-medium text-[#1A1A1A] hover:bg-gray-100 rounded-lg transition-colors"
              >
                <img 
                  src="/images/black-streamline-sharp_buttons-all-solid.png" 
                  className="w-4 h-4" 
                  alt="All" 
                />
                <span>All Products</span>
              </button>
            </div>

            {/* ✅ NEW: Mobile Menu as FIXED OVERLAY - No Layout Shift */}
            {isMobileMenuOpen && (
              <>
                {/* Backdrop */}
                <div 
                  className="fixed inset-0 bg-black bg-opacity-50 z-[90] lg:hidden"
                  style={{ animation: 'fadeIn 0.2s ease-in-out' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                />
                
                {/* Slide-in Menu */}
                <div 
                  ref={mobileMenuRef}
                  className="fixed top-0 left-0 h-full w-[280px] bg-white z-[100] shadow-2xl lg:hidden"
                  style={{ animation: 'slideInLeft 0.3s ease-out' }}
                >
                  {/* Menu Header */}
                  <div className="flex justify-between items-center p-4 border-b border-gray-200">
                    <h3 className="text-lg font-semibold text-[#1A1A1A]">Menu</h3>
                    <button 
                      onClick={() => setIsMobileMenuOpen(false)}
                      className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                      aria-label="Close menu"
                    >
                      <X className="w-5 h-5" />
                    </button>
                  </div>
                  
                  {/* Menu Content */}
                  <ul className="flex flex-col p-4">
                    <li className="border-b border-gray-100">
                      <Link 
                        to="/brands" 
                        className="block py-4 font-semibold text-[#1A1A1A] hover:text-gray-600 transition-colors" 
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        Brands
                      </Link>
                    </li>
                    <li className="border-b border-gray-100">
                      <Link 
                        to="/about-us" 
                        className="block py-4 font-semibold text-[#1A1A1A] hover:text-gray-600 transition-colors" 
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="/contact" 
                        className="block py-4 font-semibold text-[#1A1A1A] hover:text-gray-600 transition-colors" 
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        Contact Us
                      </Link>
                    </li>
                  </ul>
                </div>
              </>
            )}

            {/* Mobile Search */}
            <div className="relative" ref={searchRef}>
              <form 
                onSubmit={handleSearchSubmit} 
                className="bg-white rounded-md p-2" 
                style={{ boxShadow: "0px 1px 2px #B8C8E039" }}
              >
                <fieldset className="flex bg-[#F5F1E6] mb-2">
                  <input 
                    type="radio" 
                    id="buy-mobile" 
                    name="intent-mobile" 
                    checked={searchType === "buy"} 
                    onChange={() => handleSearchTypeChange("buy")} 
                    className="peer/buy sr-only" 
                  />
                  <label 
                    htmlFor="buy-mobile" 
                    className="flex-1 text-center py-2 text-sm font-semibold cursor-pointer peer-checked/buy:bg-[#FFD200] transition-colors"
                  >
                    Buy
                  </label>
                  
                  <input 
                    type="radio" 
                    id="rent-mobile" 
                    name="intent-mobile" 
                    checked={searchType === "rent"} 
                    onChange={() => handleSearchTypeChange("rent")} 
                    className="peer/rent sr-only" 
                  />
                  <label 
                    htmlFor="rent-mobile" 
                    className="flex-1 text-center py-2 text-sm font-semibold cursor-pointer peer-checked/rent:bg-[#FFD200] transition-colors"
                  >
                    Rent
                  </label>
                </fieldset>

                <div className="relative">
                  <input
                    type="search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    onFocus={() => (searchResults.length > 0 || categoryResults.length > 0) && setShowResults(true)}
                    placeholder="What are you looking for?"
                    className="w-full h-10 pl-4 pr-16 text-base placeholder:text-gray-300 outline-none"
                    autoComplete="off"
                  />
                  
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 flex gap-2 items-center">
                    {isSearching && (
                      <Loader2 className="w-4 h-4 text-gray-400 animate-spin" />
                    )}
                    {searchQuery && !isSearching && (
                      <button 
                        type="button" 
                        onClick={handleClearSearch}
                        aria-label="Clear search"
                        className="hover:bg-gray-100 rounded p-0.5 transition-colors"
                      >
                        <X className="w-4 h-4 text-gray-400" />
                      </button>
                    )}
                    <button 
                      type="submit" 
                      disabled={!searchQuery.trim()}
                      aria-label="Submit search"
                      className="disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <Search className="w-5 h-5 text-gray-400" />
                    </button>
                  </div>
                </div>
              </form>
              
              <SearchResultsDropdown isMobile={true} />
            </div>
          </div>
        </div>
      </div>

      <CategoryPopup
        isOpen={isPopupOpen}
        onClose={handleClosePopup}
        onSelectCategory={handleCategorySelect}
        onMouseEnter={handlePopupMouseEnter}
        onMouseLeave={handlePopupMouseLeave}
        triggerRef={window.innerWidth >= 1024 ? allProductsButtonRef : mobileAllProductsButtonRef}
      />
      
      {/* Styles */}
      <style jsx>{`
        .nav-underline {
          position: relative;
          display: inline-block;
        }
        .nav-underline::after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 0%;
          height: 2px;
          background-color: #1a1a1a;
          transition: width 0.3s ease;
        }
        .nav-underline:hover::after {
          width: 100%;
        }
        
        /* ✅ NEW: Mobile menu animations */
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        @keyframes slideInLeft {
          from {
            transform: translateX(-100%);
          }
          to {
            transform: translateX(0);
          }
        }
      `}</style>
    </>
  );
};

export default MenuAndSearchBar;